// extracted by mini-css-extract-plugin
module.exports = {"heroBanner":"HomeBanner_heroBanner__vjOBG","mobile":"HomeBanner_mobile__0FuOn","desktop":"HomeBanner_desktop__62jCh"};